import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type AccountFinancialsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type AccountFinancialsQueryResult = { __typename?: 'Query' } & {
  accountFinancials: { __typename?: 'AccountFinancialsPayload' } & Pick<
    GraphQLTypes.AccountFinancialsPayload,
    'accountId' | 'financeId'
  > & { errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>> };
};

export const AccountFinancialsDocument = gql`
  query accountFinancials($accountId: String!) {
    accountFinancials(accountId: $accountId) {
      accountId
      errors {
        message
      }
      financeId
    }
  }
`;
